import classFields from './class';

const fields = {
  items: {
    class: { ...classFields.items },
  },
};

export default fields;
